import { render } from "./ResetPassword.vue?vue&type=template&id=285842d0&scoped=true"
const script = {}

import "./ResetPassword.vue?vue&type=style&index=0&id=285842d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285842d0"]])

export default __exports__